import { gql } from '@apollo/client'
import { DocDetails } from '@jusbrasil-web/docview/core'

import { MotionDetails_DocumentFragment } from './__generated__/motion-details.graphql'
import { getDistributionDateFromLawsuit, getSubjects } from './functions'
import { LawsuitProps } from './types'

export type MotionDetailsProps = {
  document: MotionDetails_DocumentFragment
}

export function MotionDetails(props: MotionDetailsProps) {
  const { document } = props
  const { lawsuit } = document
  const { subjects = [], lawArea, judgeName, cnjNumber } = lawsuit || {}

  const pairs = [
    {
      label: 'Assunto',
      value: getSubjects(subjects),
    },
    {
      label: 'Área do direito',
      value: lawArea,
    },
    {
      label: 'Tribunal',
      value: cnjNumber?.formattedCourt,
    },
    {
      label: 'Juiz',
      value: judgeName,
    },
    {
      label: 'Data de início',
      value: getDistributionDateFromLawsuit(lawsuit as LawsuitProps),
    },
    {
      label: 'Poder judiciário',
      value: cnjNumber?.justice?.name,
    },
  ].filter((pair) => !!pair.value)

  if (pairs.length === 0) {
    return null
  }

  return <DocDetails pairs={pairs} />
}

MotionDetails.fragments = {
  document: gql`
    fragment MotionDetails_document on Document {
      lawsuit {
        lawArea
        cnjNumber {
          formattedCourt
          justice {
            name
          }
          data {
            year
          }
        }
        judgeName
        distributionDate
        subjects
      }
    }
  `,
}
